/* The real PDF URLs remain usable without JS. Enhancement saves a local Blob. */
(() => {
  function init(root) {
    if (root.dataset.pdfReady) return;
    const fallbackStatus = root.querySelector('[data-kg-pdf-status]');
    if (!fallbackStatus || !window.fetch || !URL.createObjectURL) return;
    root.dataset.pdfReady = 'true';
    root.addEventListener('click', async event => {
      const link = event.target.closest('[data-kg-pdf-download]');
      if (!link || !root.contains(link) || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (link.dataset.busy) return;
      const status = link.closest('[data-kg-pdf-card]')?.querySelector('[data-kg-pdf-status]') || fallbackStatus;
      link.dataset.busy = 'true';
      link.setAttribute('aria-busy', 'true');
      status.textContent = status.dataset.preparing;
      try {
        const response = await fetch(link.href, { credentials: 'omit' });
        if (!response.ok) throw new Error('PDF unavailable');
        const blob = await response.blob();
        if (!blob.size || await blob.slice(0, 5).text() !== '%PDF-') throw new Error('Invalid PDF response');
        const url = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
        const save = document.createElement('a');
        save.href = url; save.download = link.download; save.hidden = true;
        document.body.append(save); save.click(); save.remove();
        setTimeout(() => URL.revokeObjectURL(url), 60000);
        status.textContent = status.dataset.ready;
      } catch {
        status.textContent = status.dataset.error;
      } finally {
        delete link.dataset.busy;
        link.removeAttribute('aria-busy');
      }
    });
  }
  document.querySelectorAll('[data-kg-pdfs]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-kg-pdfs]').forEach(init));
})();
